interface LogoProps {
  variant?: "header" | "footer";
  className?: string;
}

export default function Logo({ variant = "header", className = "" }: LogoProps) {
  const isHeader = variant === "header";

  const iconSize = isHeader ? "w-14 h-14" : "w-[60px] h-[60px]";
  const textColor = isHeader ? "text-[#0C2740]" : "text-white";
  const subColor = isHeader ? "text-[#185FA5]" : "text-[#FFD600]";

  return (
    <a href="/" className={`flex items-center gap-3.5 ${className}`}>
      <svg viewBox="0 0 56 56" className={`${iconSize} flex-shrink-0`}>
        <rect width="56" height="56" rx="9" fill="#FFD600" />
        <rect
          x="9"
          y="9"
          width="38"
          height="38"
          rx="4"
          fill="none"
          stroke="#0C2740"
          strokeWidth="3.5"
        />
        <line x1="28" y1="9" x2="28" y2="47" stroke="#0C2740" strokeWidth="3.5" />
        <line x1="9" y1="28" x2="47" y2="28" stroke="#0C2740" strokeWidth="3.5" />
        <circle cx="40" cy="40" r="4" fill="#0C2740" />
      </svg>
      <div className="flex flex-col leading-none">
        <span
          className={`font-geist font-bold text-[26px] md:text-[28px] leading-tight ${textColor}`}
        >
          Ramen Repair
        </span>
        <span
          className={`font-geist font-bold text-[14px] tracking-[4px] ${subColor}`}
        >
          EINDHOVEN
        </span>
      </div>
    </a>
  );
}